var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseGray1010 = function SvgCloseGray1010(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6F7070",
    d: "M.792 10 0 9.208 4.208 5 0 .792.792 0 5 4.208 9.208 0 10 .792 5.792 5 10 9.208 9.208 10 5 5.792z"
  })));
};
export default SvgCloseGray1010;